module.exports = __webpack_public_path__ + "img/truck.e71f99f0.svg";